import React from "react";
import { ArrowLeft, MoonFill, SunFill } from "react-bootstrap-icons";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../Auth/api";
import { BoxArrowRight } from "react-bootstrap-icons";
import useAppStore from "../../store/global";
import { ToastContainer } from "react-toastify";
export default function NavHeader({ view }) {
  const navigate = useNavigate();
  const { dateRange, setDateRange, setLogType, setReportType, theme, toggleTheme } = useAppStore();
  return (
    <nav
      className="navbar navbar-brand-bg p-3 shadow-sm"
      style={{
        position: "fixed",
        top: "0",
        bottom: "100",
        zIndex: "100",
        width: "100%",
      }}
    >
      <ToastContainer />
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          width: "100%",
        }}
      >
        <div
          className="navbar-brand mb-0 h1 mx-1 text-nowrap"
          style={{ fontSize: "20px", letterSpacing: "1px" }}
        >
          {view !== "home" && (
            <ArrowLeft
              size={36}
              className="p-2"
              role="button"
              aria-label="Back"
              onClick={() => {
                navigate(-1);
                setDateRange([
                  {
                    startDate: null,
                    endDate: null,
                    key: "selection",
                  },
                ]);
                setLogType(null);
                setReportType(null);
              }}
            />
          )}
          <Link to="/" className="text-body" style={{ textDecoration: "none" }}>
            <span className="d-none d-sm-inline">Crunch Intelligence Platform</span>
            <span className="d-sm-none">Crunch</span>
          </Link>
        </div>
        <div className="d-flex align-items-center">
          <span
            className="p-2"
            role="button"
            title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            style={{ cursor: "pointer", fontSize: "18px" }}
            onClick={toggleTheme}
          >
            {theme === "dark" ? <SunFill /> : <MoonFill />}
          </span>
          {window.location.pathname !== "/login" && (
            <BoxArrowRight
              size={36}
              className="p-2"
              role="button"
              aria-label="Log out"
              style={{ cursor: "pointer" }}
              onClick={() => {
                logout();
                window.location.reload();
              }}
            />
          )}{" "}
        </div>
      </div>
    </nav>
  );
}
